const SITE_COLORS = {
  amazon: "#FF9900", flipkart: "#2874F0", myntra: "#FF3F6C", ajio: "#2C4152", snapdeal: "#E40046",
  meesho: "#9F2089", nykaa: "#FC2779", croma: "#00A79D", "tata cliq": "#000000", jiomart: "#0078AD",
};

export const siteColor = (site = "") => SITE_COLORS[site.toLowerCase()] || "#6D28D9";

export const mvPrice = (p) => p.discounted_price || p.original_price;

export const buildOffers = (product) => {
  const pc = product.price_comparison || {};
  const offers = [{ id: "mv", site: "M Ventures", price: mvPrice(product), isMV: true, cashback: product.cashback_percent }];
  (product.compare_offers || []).forEach((o) => o.price && offers.push({ ...o }));
  const legacy = [
    ["Flipkart", pc.flipkart_price, pc.flipkart_url],
    ["Amazon", pc.amazon_price, pc.amazon_url],
    [pc.other_platform_name, pc.other_platform_price, pc.other_platform_url],
  ];
  legacy.forEach(([site, price, url]) => {
    if (site && price && !offers.some((o) => o.site.toLowerCase() === site.toLowerCase())) {
      offers.push({ id: `legacy-${site.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`, site, price, url });
    }
  });
  return offers.sort((a, b) => a.price - b.price);
};

export const effectivePrice = (o) => (o.isMV ? Math.round(o.price - (o.price * (o.cashback || 0)) / 100) : o.price);

const FALLBACK_IMG = "https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?w=600&q=70";
export const imgFallback = (e) => { if (e.currentTarget.src !== FALLBACK_IMG) e.currentTarget.src = FALLBACK_IMG; };

export const inr = (n) => `₹${Math.round(Number(n) || 0).toLocaleString("en-IN")}`;
